import api, { ApiResponse } from './api';

import { Alert, UpdateAlertProps } from 'entities/Alert';

interface GetAlertListResponse {
  success: boolean;
  data: Alert[];
}

export const getAlertListService = (): ApiResponse<GetAlertListResponse> =>
  api({
    method: 'GET',
    url: 'alerts',
    useToken: true,
  });

interface UpdateAlertResponse {
  success: boolean;
  data: Alert;
}

export const updateAlertService = ({
  alertId,
  ...data
}: UpdateAlertProps): ApiResponse<UpdateAlertResponse> =>
  api({
    method: 'PATCH',
    url: `alerts/${alertId}`,
    data,
    useToken: true,
  });
